var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SubAPI } from "./SubAPI";
var ReportsAPI = /** @class */ (function (_super) {
    __extends(ReportsAPI, _super);
    function ReportsAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReportsAPI.prototype.getTable = function (input) { return this.fetcher.post("/api/reports/get-table", input); };
    ReportsAPI.prototype.getTimeSeries = function (input) { return this.fetcher.post("/api/reports/get-time-series", input); };
    ReportsAPI.prototype.get = function (input) { return this.fetcher.get("/api/report", input); };
    ReportsAPI.prototype.save = function (input) { return this.fetcher.post("/api/report", input); };
    ReportsAPI.prototype.listReports = function () { return this.fetcher.get("/api/reports/list"); };
    ReportsAPI.prototype.removeReport = function (input) { return this.fetcher.post("/api/reports/remove", input); };
    return ReportsAPI;
}(SubAPI));
export { ReportsAPI };
